import Vue from "vue";
import Router from "vue-router";
import { ENV } from "@/core/config/env";
import authority from "@/router/authority";
import form from "@/router/form";
Vue.use(Router);


export default new Router({
    mode: "history",
    routes: [
        ...authority,
        ...form,
        {
            // the 404 route, when none of the above matches
            path: '/404',
            name: "404",
            component: () => import("@/view/pages/error/Error-1.vue")
        },

    ]
});
